module.exports = __webpack_public_path__ + "img/bunkering-log.f1cf0cd3.svg";